export default "__VITE_ASSET__DgHP9l3N__"